import type { ReactNode } from 'react';

import type { HistogramSeries } from '../types/histogram.js';

/**
 * The Select subcomponent props
 * @public
 */
export interface SelectProps {
  /**
   * Custom actions handler
   * @param selectedSeries - the series selected in the range, with the specific subset of selected bins
   * @param selectionDomain - the domain of the selection as `[from, to]`
   */
  actions?: (
    selectedSeries: HistogramSeries[],
    selectionDomain: [number, number],
  ) => ReactNode | Promise<ReactNode>;
}

/**
 * @public
 */
export const Select = (props: SelectProps) => null;

Select['displayName'] = 'HistogramChart.Select';
